// @flow

import React, { Component } from 'react'
import styled from 'styled-components'
import { zIndexes } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'

export default class PopupWrapper extends Component<*> {
  render() {
    return (
      <Background>
        <Container>{this.props.children}</Container>
      </Background>
    )
  }
}

const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: ${zIndexes.topmost};
`
const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`
